export default "__VITE_ASSET__HCnI77wT__"